import { createAction } from 'typesafe-actions';

import type { TeamStats, TeamEventStats } from '@common/stats';
import type { Team, TeamID, TeamOrOrgListGroupedBySeason, TeamOpponent } from './types';

export const addTeams = createAction('team/ADD', (wrapPayload) => (teams: Team[]) => wrapPayload(teams));

export const addMeTeams = createAction(
    'meTeams/ADD',
    (wrapPayload) => (teams: TeamOrOrgListGroupedBySeason[]) => wrapPayload(teams),
);

export const addMeTeamRecords = createAction(
    'meTeams/ADD_RECORDS',
    (wrapPayload) => (teamRecords: { teamID: TeamID; record: string | undefined }[]) => wrapPayload(teamRecords),
);

export const selectTeam = createAction('team/SELECT', (wrapPayload) => (team: Team) => wrapPayload(team));

export const addSeasonStats = createAction(
    'seasonStats/ADD',
    (wrapPayload) => (seasonStats: TeamStats) => wrapPayload(seasonStats),
);
export const clearSeasonStats = createAction('seasonStats/CLEAR');

export const addGameStats = createAction(
    'gameStats/ADD',
    (wrapPayload) => (teamID: TeamID, gameStats: TeamStats) => wrapPayload({ teamID, gameStats }),
);
export const clearGameStatsForTeam = createAction(
    'gameStats/CLEARTEAM',
    (wrapPayload) => (teamID: TeamID) => wrapPayload({ teamID }),
);

export const clearAllGameStats = createAction('gameStats/CLEAR');

export const addPlayerStats = createAction(
    'playerStats/ADD',
    (wrapPayload) => (playerStats: TeamEventStats) => wrapPayload(playerStats),
);
export const clearPlayerStats = createAction('playerStats/CLEAR');

export const addTeamOpponents = createAction(
    'opponents/ADD',
    (wrapPayload) => (opponents: TeamOpponent[]) => wrapPayload(opponents),
);

export const selectTeamOpponent = createAction(
    'opponent/SELECT',
    (wrapPayload) => (opponent: TeamOpponent) => wrapPayload(opponent),
);
